import { create } from "zustand";
import { Card } from "../types/Card";
import { CardFormValues } from "../types/Card";

interface CurrentTalentState {
  cards: CardFormValues[];
  setCards: (card: CardFormValues[]) => void;
}


export const useCardStore = create<CurrentTalentState>()((set) => ({
  cards: [],
  setCards: (card: CardFormValues[]) =>
    set((state) => ({
      cards: card,
    })),
}));
